module.exports = __webpack_public_path__ + "static/media/cert2.80be88c0.png";